import AutoSlider from './../components/AutoSlider'
import { $ } from './../helpers/query'

export default () => {
  setPhotosDecorationSizes()
  window.addEventListener('resize', setPhotosDecorationSizes)

  function setPhotosDecorationSizes() {
    const introSection = document.querySelector('#intro-section');
    const prevDecorationLand = introSection.querySelector('.intro__decoration .intro__decoration--land');
    const prevDecorationPort = introSection.querySelector('.intro__decoration .intro__decoration--port');
    const isLandscape = document.documentElement.clientWidth > document.documentElement.clientHeight;
    const prevDecoration = isLandscape ? prevDecorationLand : prevDecorationPort;
    const width = prevDecoration.getBoundingClientRect().right;
    $('.photos__decoration').css({ width: width + 'px' });
  }

  const photosCarousel = new AutoSlider('#photos-section .photos__carousel');
  photosCarousel.init()
}
